module.exports = __webpack_public_path__ + "img/ico_calendar.95c5613d.svg";